import styled, { css } from "styled-components";
import { themeGet } from "styled-system";

export const diffStyles = css`
  & del *,
  & ins * {
    width: fit-content;
  }
  & del,
  & del * {
    text-decoration: none;
    color: ${themeGet("colors.messages.error")};
    background: repeating-linear-gradient(
        to right,
        ${themeGet("colors.messages.error")} 0 4px,
        transparent 4px 6px
      )
      bottom/100% 2px no-repeat;
  }
  & ins,
  & ins * {
    text-decoration: none;
    color: ${themeGet("colors.messages.success")};
    background: repeating-linear-gradient(
          to right,
          ${themeGet("colors.messages.success")} 0 1px,
          transparent 1px 7px
        )
        bottom 0 left 2px/100% 5px no-repeat,
      repeating-linear-gradient(
          to right,
          ${themeGet("colors.messages.success")} 0 5px,
          transparent 5px 7px
        )
        bottom 2px left 0/100% 1px no-repeat;
    padding-bottom: 4px;
  }
`;

// This component - just container for styles applying.
// It doesn't contain any logic, but just styling for <del> and <ins> elements
const DiffContainer = styled("section")`
  ${diffStyles}
`;

export const MockDiffContent = () => (
  <main>
    <h1>
      This is mocked header. <ins>This was added</ins>
      <del>And this was deleted</del>
    </h1>
    <section>
      And this is just some text.{" "}
      <ins>This is pretty important addition, it was added.</ins>
      <del>This was some redundant text, now it's gone.</del>
      After deleted text goes some other, still relevant, information. Blah blah
      blah, I am relevant text, blah blah blah.
    </section>
  </main>
);

export default DiffContainer;
